uniform float uTime;
uniform vec2 uResolution;
uniform vec3 uColor;
uniform float uInnerSmooth;
uniform float uOuterSmooth1;
uniform float uOuterSmooth2;
uniform float uRingWidth;
varying vec2 vUv;


float inverseLerp(float v, float minValue, float maxValue) {
    return (v - minValue) / (maxValue - minValue);
}
float remap( float v, float inMin, float inMax, float outMin, float outMax ) {
    float t = inverseLerp(v, inMin, inMax);
    return mix(outMin, outMax, t);
}

// 2D Random
float random (in vec2 st) {
    return fract(sin(dot(st.xy,
                         vec2(12.9898,78.233)))
                 * 43758.5453123);
}

mat2 rotate2d(float _angle){
    return mat2(cos(_angle),-sin(_angle),
                sin(_angle),cos(_angle));
}


float hash(float n) { return fract(sin(n) * 1e4); }
float hash(vec2 p) { return fract(1e4 * sin(17.0 * p.x + p.y * 0.1) * (0.1 + abs(sin(p.y * 13.0 + p.x)))); }

// 2D Noise based on Morgan McGuire @morgan3d
// https://www.shadertoy.com/view/4dS3Wd
float noise(vec2 x) {
	vec2 i = floor(x);
	vec2 f = fract(x);

	// Four corners in 2D of a tile
	float a = hash(i);
	float b = hash(i + vec2(1.0, 0.0));
	float c = hash(i + vec2(0.0, 1.0));
	float d = hash(i + vec2(1.0, 1.0));

	// Simple 2D lerp using smoothstep envelope between the values.
	// return vec3(mix(mix(a, b, smoothstep(0.0, 1.0, f.x)),
	//			mix(c, d, smoothstep(0.0, 1.0, f.x)),
	//			smoothstep(0.0, 1.0, f.y)));

	// Same code, with the clamps in smoothstep and common subexpressions
	// optimized away.
	vec2 u = f * f * (3.0 - 2.0 * f);
	return mix(a, b, u.x) + (c - a) * u.y * (1.0 - u.x) + (d - b) * u.x * u.y;
}


void main() {
  //resolution====================
  vec2 uv = vUv;
  //moving 0 to center====================
  uv = uv - 0.5;
  //setting range from -1 to 1====================
  uv = uv * 2.0;
  //aspect ratio====================
  // uv.x = uv.x * uResolution.x / uResolution.y;


  float d = length(uv);
  d -= 0.92;
  d = abs(d);
  // d = smoothstep(0.0, 0.08, d);
  d = 0.04 / d;
  float n = noise(uv * 15. + uTime/2.);
  // n = remap(n, 0.0, 1.0, 0.0, 0.9); 
  d -= n;
  


  //colors====================
  vec3 color = vec3(d,d,d);
  vec3 black = vec3(0.0);
  vec3 white = vec3(1.0);
  vec3 orange = vec3(-1.0, 0.6, 0.4);
  //option 2====================
  // orange = uColor;
  // orange *= vec3(9.0, 9.0, 9.0);
  orange *= vec3(2.0, 1.0, 1.0);
  color *= uColor * 0.3;
  // color = mix(black, uColor * 2., d);



  gl_FragColor = vec4(color, d-0.20);
  // gl_FragColor = vec4(uv,1.0,1.0);
  #include <colorspace_fragment>
}














// void main() {
//   //resolution====================
//   vec2 uv = vUv;
//   //moving 0 to center====================
//   uv = uv - 0.5;
//   //setting range from -1 to 1====================
//   uv = uv * 2.0;
//   //aspect ratio====================
//   // uv.x = uv.x * uResolution.x / uResolution.y;


//   float d = length(uv);
//   d = sin(d * 62. - uTime * 0.9)/62.;
//   d = abs(d);
//   d = (0.01 / d);
//   d = pow(6.28 / d, 1.2);
  


//   //colors====================
//   vec3 color = vec3(d,d,d);
//   vec3 black = vec3(0.0);
//   vec3 white = vec3(1.0);
//   vec3 orange = vec3(3.0, 0.6, 0.4);
//   //option 2====================
//   // orange = uColor;
//   // orange *= vec3(9.0, 9.0, 9.0);
//   orange *= vec3(2.0, 1.0, 1.0);

//   color = orange;
//   color *= d;
//   color = mix(black, color, 1.0 - smoothstep(0.0, 0.80,length(uv)));
//   color *= smoothstep(0.48, 0.6, length(uv));


//   //alpha====================
//   float alpha = smoothstep(0.48, 0.5, length(uv)) * 1.0 - smoothstep(0.78, 0.8, length(uv));
//   // alpha = 1.0;

//   gl_FragColor = vec4(color, alpha);
//   // gl_FragColor = vec4(uv,1.0,1.0);
//   // #include <colorspace_fragment>
// }